import { useRef, useState, useEffect } from "react";
import ReactQuill from "react-quill";
import { useTerminalConfig } from "../../Path/NewTerminalConfigs";
import { useTranslation } from "react-i18next";
const modules = {
    toolbar: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
        ['link', 'image'],
        ['clean']
    ],
    clipboard: {
        matchVisual: false,
    },
};

const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image'
];

const FreeQuery = () => {
    const { terminalConfig, setTerminalConfig } = useTerminalConfig();
    const [localQuery, setLocalQuery] = useState(terminalConfig?.query || "");
    const editor = useRef(null);
    const { t } = useTranslation();
    useEffect(() => {
        setLocalQuery(terminalConfig?.query || '')
    }, [terminalConfig?.query])

    return <div className="mt-6">
        <h2 className="text-xl font-semibold mb-2 text-white">{t("add_custom_request")}</h2>
        <ReactQuill
            type="text"
            id="description"
            name="description"
            ref={editor}
            value={localQuery || terminalConfig?.query}
            onChange={(value) => {
                setLocalQuery(value);
                setTerminalConfig((prev) => ({
                    ...prev,
                    query: value
                }));
            }}
            onBlur={() => {
                setTerminalConfig((prev) => ({
                    ...prev,
                    query: localQuery
                }));
            }}
            modules={modules}
            formats={formats}
            readOnly={false}
            placeholder={t("write_something")}
            className="w-full bg-white rounded border border-gray-300 focus:border-black focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-0 px-0 leading-8 transition-colors duration-200 ease-in-out shadow-md"
        />
    </div>
}

export default FreeQuery;
